import ApiRequestManagerInstance from '../ApiRequestManager';
import Promo from '../../classes/slider';
import TranslationManager from '../../assets/locale/translationsManager';
import { ISlider, ISliderRequest } from '../../types/interfaces/slider';
import { store } from '../../store/store';

function promoRequest(id: string) {
  const promise = new Promise<ISlider[]>(async (resolve) => {
    try {
      const { user } = store.getState();
      const response: ISliderRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          section: `media${user.isAnonymous ? 'free' : ''}`,
          subsection: 'corner',
          type: 'promos',
          params: id + '?lang=' + TranslationManager.currentLanguage,
        },
      })) as unknown as ISliderRequest;
      let promos: ISlider[] = [];
      if (response?.data?.length) {
        promos = response.data?.map((item, index) => new Promo(item, index));
      }
      resolve(promos);
    } catch (e) {
      resolve([]);
    }
  });

  return promise;
}

export default promoRequest;
